<template lang="pug">
section.connection-rms-component
    dialog-s(:dialog="dialog" @dialogClose="() => {}")
        template(v-if="rmsConnectStatus === 0")
            template(slot="content" )
              el-popover(
                  transition="el-zoom-in-top"
                  @show="() => helpIconIs = '#code-lab-set-teach-help-active-icon'"
                  @hide="() => helpIconIs = '#code-lab-set-teach-help-icon'"
                  popper-class="public-provide-component-add set-teach-connnection-popover"
                  placement="bottom"
                  width="210"
                  trigger="click"
                  :content="attrStrConnection1")
                span(slot="reference", :class="shit$(`cursor:p; absolute; top:20px; left:20px; w:20px; h:20px; lh:20px;`)",)
                  svg-icon(:href="helpIconIs", height="20", width="20", )
              div(:class="shit$(`h:40px; dis:f; justify-c:sb; pl:16px; pr:29px; c:#a8a8ac;`)") 
                span(:class="shit$(`font:14px;`)") {{this.$t( "code-lab/component/connection/set-teach-connnection.vue_0" ) }}
                span(:class="shit$(`font:14px;`)") {{this.$t( "code-lab/component/connection/set-teach-connnection.vue_1" ) }} {{ connection.length || '00' }} {{this.$t( "code-lab/component/connection/set-teach-connnection.vue_2" ) }}
              tree-s(class="contentTree" @treeData="handleDataFromTreeComponent" :data="rmsDevices" :defaultCheckedKeys="connectionId")
        template(v-else-if="rmsConnectStatus === 1")
            section(class="successContent" slot="content")
                img(:src="`${env$}static/svg/connect/sucess.svg`")
        template(v-else)
            section(slot="content" :class="['failedContent', shit$(`text-a:c; py:25px; mb:-20px;`)]")
                img(:src="`${env$}static/svg/connect/failed.svg`")
                p(:class="[shit$(`font:14px; c:#fff; letter-s:1px;`)]") {{this.$t( "code-lab/component/connection/set-teach-connnection.vue_3" ) }}！{{this.$t( "code-lab/component/connection/set-teach-connnection.vue_4" ) }}，{{this.$t( "code-lab/component/connection/set-teach-connnection.vue_5" ) }}。
        div(slot="footer" class="footerBtn")
            el-button(class="cncelConnect" @click="closeComponent") {{ dialog.one.label }}
            el-button(class="confirmConnect" @click="confirmConnect"
              :class="[(allowedConnect || rmsConnectStatus === 2) && shit$(`bgc:rgba(14, 211, 255, 0.6)!; c:#fff!;`), (!allowedConnect && rmsConnectStatus !== 2) && shit$(`cursor:n;`)]") {{ dialog.two.label }}
</template>

<script>
import TreeS from "@/code-lab/view/organization/s-tree.vue";
import DialogS from "@/code-lab/view/organization/s-dialog.vue";
import { store } from "@/code-lab/component/robot-connect/device-manage/observable/store.js";
import connectRequestMix from "@/code-lab/component/connection/connect-request-mix.js";
import { mapGetters, mapState } from "vuex";
export default {
  name: "connection-rms-component",
  components: { TreeS, DialogS },
  mixins: [connectRequestMix],
  props: {
    show: Boolean
  },
  computed: {
    ...mapState(["env$"]),
    ...mapGetters('user', [
        'hansRmsScope'
    ]),
    ...mapState("rmsConnection", {
      allDevice: "allDevice",
      rmsConnectDevices: "connectDevices"
    }),
    ...mapState("teachConnection", {
      connectDevices: "connectDevices",
      rmsDevices: "rmsDevices"
    })
  },
  watch: {
    show(newValue) {
      this.dialog.isShow = newValue;
    },
    rmsConnectStatus: {
      immediate: true,
      async handler(newVal) {
        if (newVal === 1) {
          Object.assign(this.dialog, { isFooter: false, title: this.$t( "code-lab/component/connection/set-teach-connnection.vue_6" ) });
          setTimeout(() => this.closeComponent(), 1000);
        } else if (newVal === 2) {
          Object.assign(this.dialog, {
            isFooter: true,
            title: this.$t( "code-lab/component/connection/set-teach-connnection.vue_7" ),
            two: { label: this.$t( "code-lab/component/connection/set-teach-connnection.vue_8" ) }
          });
          setTimeout(() => this.closeComponent(), 3000);
        } else {
          Object.assign(this.dialog, {
            isFooter: true,
            title: this.$t( "code-lab/component/connection/set-teach-connnection.vue_9" ),
            two: { label: this.$t( "code-lab/component/connection/set-teach-connnection.vue_10" ) }
          });
        }
      }
    }
  },
  data() {
    return {
      attrStrConnection1: this.$t("code-lab/component/connection/set-teach-connnection.vue_11"),
      dialog: {
        width: "400px",
        isShow: true,
        closeOnEscape: false,
        closeOnModal: true,
        showClose: false,
        class: "connectStatusDialog",
        isFooter: true,
        title: this.$t( "code-lab/component/connection/set-teach-connnection.vue_12" ),
        one: { label: this.$t( "code-lab/component/connection/set-teach-connnection.vue_13" ) },
        two: { label: this.$t( "code-lab/component/connection/set-teach-connnection.vue_14" ) }
      },
      connection: [],
      connected: [],
      connectionId: [],
      allowedConnect: false,
      rmsConnectStatus: 0,
      helpIconIs: "#code-lab-set-teach-help-icon"
    };
  },
  async created() {
    if (this.hansRmsScope) {
      
      
      
      this.connectionId = this.connectDevices.map(mo => mo.id);
      this.connection = JSON.parse(JSON.stringify(this.connectDevices));
    }
  },
  methods: {
    async confirmConnect() {
      if (this.rmsConnectStatus === 2) return this.closeComponent();
      if (!this.allowedConnect) return console.error("not allowed connect");
      let hostDeviceIds = [],
        deviceIds = [];
      this.allDevice.forEach(fl => {
        this.connection.some(fd => fl.deviceId === fd.deviceId)
          ? hostDeviceIds.push(fl.deviceId)
          : deviceIds.push(fl.deviceId);
      });
      await this.apiCallAddDevices({
        hostDeviceIds,
        deviceIds
      });
      const reseponse2 = await this.apiCallCurrentDevices();
      const o = reseponse2.body.data;
      const fn = (data, type = "student") =>
        data.map(mp => Object.assign(mp, { type$: type }));
      this.$store.commit("rmsConnection/allDevice", [
        ...fn(o.hostDeviceIds, "teacher"),
        ...fn(o.deviceIds, "student")
      ]);

      const connection = this.rmsConnectDevices.filter(fl =>
        this.allDevice.some(so => fl.deviceId === so.deviceId)
      );
      this.$store.commit(
        "teachConnection/HANDLERMSDEVICES",
        this.util$.copyObj$(connection)
      ); 
      this.$store.commit(
        "setDevicePlay/HANDLERMSDEVICES",
        this.util$.copyObj$(connection)
      ); 

      this.$store.commit(
        "teachConnection/HANDLECONNECTDEVICES",
        this.connection
      );
      store.commit("pop/switchIs", { switchIs: false });
      store.commit("button/clickData", { clickData: false });
    },
    handleDataFromTreeComponent({ node, check }) {
      let target = [];
      node.devices &&
        (target = node.devices.map(mp => ({
          deviceId: mp.deviceId,
          id: mp.id
        })));
      node.deviceId && target.push({ deviceId: node.deviceId, id: node.id });
      if (!target.length) return;

      const { strs, objs } = check.checkedNodes.reduce(
        (pre, nex) => ({
          strs: Array.from(
            new Set([
              ...pre.strs,
              ...(nex.devices
                ? nex.devices.map(m => m.deviceId)
                : [nex.deviceId])
            ])
          ),
          objs: [
            ...pre.objs,
            ...(nex.devices ? nex.devices.map(m => m) : [nex])
          ]
        }),
        { strs: [], objs: [] }
      );

      this.connection = strs.map(ms => objs.find(fo => fo.deviceId === ms));

      const connectionIds = this.connection.map(mo => mo.deviceId);
      const connectDevicesIds = this.connectDevices.map(mo => mo.deviceId);
      if (!connectionIds.length) {
        this.allowedConnect = false;
      } else if (
        connectDevicesIds.length &&
        connectionIds.length !== connectDevicesIds.length
      ) {
        this.allowedConnect = true;
      } else {
        const result = connectionIds.map(mp =>
          connectDevicesIds.some(so => so === mp)
        );
        const resultJudge = result.every(eo => eo);
        this.allowedConnect = !resultJudge;
      }
    },
    async requestData() {
      const connected = this.connectDevices;
      const allDevices = this.rmsDevices.reduce(
        (pre, nex) => [
          ...pre,
          ...(nex.devices ? nex.devices.map(m => m) : [nex])
        ],
        []
      );
      const connectionedDeviceIds = connected.map(mo => mo.deviceId);
      const connectedDevices = connectionedDeviceIds
        .map(mp => allDevices.find(fo => fo.deviceId === mp))
        .filter(f => f);
      const connectedDevicesTreeIds = connectedDevices.map(mp => mp.id);
      this.connectionId = connectedDevicesTreeIds;
      
    },
    closeComponent() {
      this.$store.commit("teachConnection/switchRmsHandler", false);
    }
  }
};
</script>

<style lang="scss" scoped>
.footerBtn {
  position: absolute;
  left: 0px;
  height: 100px;
  background-color: $--codelab-primary-black-2;
  width: 100%;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.5);
  text-align: center;
  line-height: 100px;

  padding: 0px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .cncelConnect {
    width: 160px;
    height: 48px;
    background: $--codelab-primary-gray-1;
    border-radius: 32.5px;
    color: #fff;
    border: none;
    font-size: 16px;
    letter-spacing: 0.48px;
    &:active {
      opacity: 0.5;
    }
  }
  .confirmConnect {
    width: 160px;
    height: 48px;
    background: $--codelab-primary-black-3;
    border-radius: 32.5px;
    color: $--codelab-primary-gray-3;
    border: none;
    font-size: 16px;
    letter-spacing: 0.48px;
    &:active {
      opacity: 0.5;
    }
  }
}
.contentTree {
  height: 269px;
  overflow: auto;
  background-color: $--codelab-primary-black-2;
}
.successContent {
  padding: 25px 0px 30px 0px;
  display: flex;
  justify-content: center;
}
</style>

<style lang="scss">
.connection-rms-component {
  .el-dialog__body {
    padding: 0px 0px 0px;
    background-color: $--codelab-primary-black-2;
    border-radius: 0px 0px 24px 24px;
  }
  .el-dialog__title {
    color: #ffffff;
  }
  .el-dialog__header {
    padding: 14px 20px 0px;
    background-color: $--codelab-primary-black-1;
    border-radius: 24px 24px 0px 0px;
  }
  .el-dialog {
    border-radius: 30px;
  }
}
.set-teach-connnection-popover {
  padding: 12px !important;
  color: #fff;
  font-size: 12px;
  letter-spacing: 0.6px;
}
</style>

